import BaseService from './BaseService';
import * as apiroutes from '../apiRoutes';
import axiosInstance from './axios';

class LoginService extends BaseService {
    constructor() {
        super(apiroutes.LOGIN);
    }

    /**
     * Login user with email and password
     * @param {string} email - User email
     * @param {string} password - User password
     * @returns {Promise} API response with user data and tokens
     */
    async login(email, password) {
        try {
            const response = await axiosInstance.post(apiroutes.LOGIN, {
                email,
                password
            });

            return response.data;
        } catch (error) {
            console.error('Login error:', error);
            throw error;
        }
    }

    /**
     * Refresh access token using refresh token
     * @param {string} refreshToken - The refresh token
     * @returns {Promise} API response with new tokens
     */
    async refreshToken(refreshToken) {
        try {
            const response = await axiosInstance.post('/api/restaurant/auth/refresh', {
                refreshToken
            });

            return response.data;
        } catch (error) {
            console.error('Token refresh error:', error);
            throw error;
        }
    }

    /**
     * Logout user
     * @param {string} refreshToken - The refresh token to invalidate
     * @returns {Promise} API response
     */
    async logout(refreshToken) {
        try {
            const response = await axiosInstance.post('/api/restaurant/auth/logout', {
                refreshToken
            });

            return response.data;
        } catch (error) {
            console.error('Logout error:', error);
            // Don't throw error on logout failure - still clear local data
            return null;
        }
    }

    /**
     * Validate token
     * @param {string} token - The access token to validate
     * @returns {Promise} API response with token validity
     */
    async validateToken(token) {
        try {
            const response = await axiosInstance.post('/api/restaurant/auth/validate', {
                token
            });

            return response.data;
        } catch (error) {
            console.error('Token validation error:', error);
            throw error;
        }
    }
}

const LoginServices = new LoginService();
export default LoginServices;